import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  type AdminPortalFaqCreatePayload,
  type AdminPortalFaqItem,
  type AdminPortalFaqUpdatePayload,
  portalFaqServices,
} from './services';

export type { AdminPortalFaqCreatePayload, AdminPortalFaqItem, AdminPortalFaqUpdatePayload };

export const listPortalFaqs = createAsyncThunk<AdminPortalFaqItem[]>('portalFaq/list', async () => {
  return await portalFaqServices.list();
});

export const createPortalFaq = createAsyncThunk<AdminPortalFaqItem, AdminPortalFaqCreatePayload>(
  'portalFaq/create',
  async (payload) => {
    return await portalFaqServices.create(payload);
  },
);

export const updatePortalFaq = createAsyncThunk<
  AdminPortalFaqItem,
  { id: string; payload: AdminPortalFaqUpdatePayload }
>('portalFaq/update', async ({ id, payload }) => {
  return await portalFaqServices.update(id, payload);
});

export const deletePortalFaq = createAsyncThunk<string, string>('portalFaq/delete', async (id) => {
  await portalFaqServices.delete(id);
  return id;
});

export const reorderPortalFaqs = createAsyncThunk<string[], string[]>(
  'portalFaq/reorder',
  async (orderedIds) => {
    await portalFaqServices.reorder(orderedIds);
    return orderedIds;
  },
);
